export enum Flows {
  Regular = 'subscription'
}

export enum StepGroups {
  Intro = 'intro',
  Pet = 'my-pup',
  Products = 'products'
}

export enum SubflowSteps {
  Intro = '/intro',
  Name = '/name',
  Email = '/email',
  GenderBreed = '/gender',
  Age = '/age',
  WeightActivity = '/weight',
  Waistline = '/waistline',
  SensitivitiesGoals = '/sensitivities',
  PlanPreferences = '/plan-preferences',
  CalculatingPlan = '/calculating-plan',
  Plans = '/plans',
  PlanConfirmation = '/plan-confirmation'
}

export type StepPath = keyof {
  [S in SubflowSteps as `/${Flows}${S}`]: true;
};

export type Step = {
  path: SubflowSteps;
  group: StepGroups;
  fullPath: StepPath;
};
